import { createContext, useState } from "react";
import text from './initData.json'
export const DataCenterContext = createContext()
const initRes = {
    text,
    tabKey: 'input',
    classes: [],
    sentences: [],
    keywords: {
        words: [],
        relations: []
    },
    entities: {
        words: [],
        relations: []
    },
    xlink: {
        words: [],
        relations: []
    },
    relation_open: {
        words: [],
        relations: []
    },
    merged: {
        words: [],
        relations: []
    },
}
export function DataCenterProvider(props) {
    const [data, setData] = useState(initRes)
    const update = (newData) => setData({ ...data, ...newData })
    return <DataCenterContext.Provider value={[data, update]}>
        {props.children}
    </DataCenterContext.Provider>
}